/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PolicyRouteImport } from './routes/policy'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as RoomRoomIdRouteImport } from './routes/room/$roomId'
import { Route as AppOrganizationRouteImport } from './routes/_app/organization'
import { Route as AppAgentsIndexRouteImport } from './routes/_app/agents.index'
import { Route as AppAgentsGenerateRouteImport } from './routes/_app/agents.generate'
import { Route as AppAgentsAgentIdRouteImport } from './routes/_app/agents.$agentId'
import { Route as AppAgentsAgentIdIndexRouteImport } from './routes/_app/agents.$agentId/index'
import { Route as AppAgentsAgentIdConfigRouteImport } from './routes/_app/agents.$agentId/config'
import { Route as AppAgentsAgentIdAnalyticsRouteImport } from './routes/_app/agents.$agentId/analytics'

const PolicyRoute = PolicyRouteImport.update({
  id: '/policy',
  path: '/policy',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const RoomRoomIdRoute = RoomRoomIdRouteImport.update({
  id: '/room/$roomId',
  path: '/room/$roomId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppOrganizationRoute = AppOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsIndexRoute = AppAgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsGenerateRoute = AppAgentsGenerateRouteImport.update({
  id: '/agents/generate',
  path: '/agents/generate',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsAgentIdRoute = AppAgentsAgentIdRouteImport.update({
  id: '/agents/$agentId',
  path: '/agents/$agentId',
  getParentRoute: () => AppRoute,
} as any)
const AppAgentsAgentIdIndexRoute = AppAgentsAgentIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAgentsAgentIdRoute,
} as any)
const AppAgentsAgentIdConfigRoute = AppAgentsAgentIdConfigRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => AppAgentsAgentIdRoute,
} as any)
const AppAgentsAgentIdAnalyticsRoute =
  AppAgentsAgentIdAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AppAgentsAgentIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/policy': typeof PolicyRoute
  '/organization': typeof AppOrganizationRoute
  '/room/$roomId': typeof RoomRoomIdRoute
  '/agents/$agentId': typeof AppAgentsAgentIdRouteWithChildren
  '/agents/generate': typeof AppAgentsGenerateRoute
  '/agents/': typeof AppAgentsIndexRoute
  '/agents/$agentId/analytics': typeof AppAgentsAgentIdAnalyticsRoute
  '/agents/$agentId/config': typeof AppAgentsAgentIdConfigRoute
  '/agents/$agentId/': typeof AppAgentsAgentIdIndexRoute
}
export interface FileRoutesByTo {
  '/policy': typeof PolicyRoute
  '/organization': typeof AppOrganizationRoute
  '/room/$roomId': typeof RoomRoomIdRoute
  '/': typeof AppIndexRoute
  '/agents/generate': typeof AppAgentsGenerateRoute
  '/agents': typeof AppAgentsIndexRoute
  '/agents/$agentId/analytics': typeof AppAgentsAgentIdAnalyticsRoute
  '/agents/$agentId/config': typeof AppAgentsAgentIdConfigRoute
  '/agents/$agentId': typeof AppAgentsAgentIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/policy': typeof PolicyRoute
  '/_app/organization': typeof AppOrganizationRoute
  '/room/$roomId': typeof RoomRoomIdRoute
  '/_app/': typeof AppIndexRoute
  '/_app/agents/$agentId': typeof AppAgentsAgentIdRouteWithChildren
  '/_app/agents/generate': typeof AppAgentsGenerateRoute
  '/_app/agents/': typeof AppAgentsIndexRoute
  '/_app/agents/$agentId/analytics': typeof AppAgentsAgentIdAnalyticsRoute
  '/_app/agents/$agentId/config': typeof AppAgentsAgentIdConfigRoute
  '/_app/agents/$agentId/': typeof AppAgentsAgentIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/policy'
    | '/organization'
    | '/room/$roomId'
    | '/agents/$agentId'
    | '/agents/generate'
    | '/agents/'
    | '/agents/$agentId/analytics'
    | '/agents/$agentId/config'
    | '/agents/$agentId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/policy'
    | '/organization'
    | '/room/$roomId'
    | '/'
    | '/agents/generate'
    | '/agents'
    | '/agents/$agentId/analytics'
    | '/agents/$agentId/config'
    | '/agents/$agentId'
  id:
    | '__root__'
    | '/_app'
    | '/policy'
    | '/_app/organization'
    | '/room/$roomId'
    | '/_app/'
    | '/_app/agents/$agentId'
    | '/_app/agents/generate'
    | '/_app/agents/'
    | '/_app/agents/$agentId/analytics'
    | '/_app/agents/$agentId/config'
    | '/_app/agents/$agentId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  PolicyRoute: typeof PolicyRoute
  RoomRoomIdRoute: typeof RoomRoomIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/policy': {
      id: '/policy'
      path: '/policy'
      fullPath: '/policy'
      preLoaderRoute: typeof PolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/room/$roomId': {
      id: '/room/$roomId'
      path: '/room/$roomId'
      fullPath: '/room/$roomId'
      preLoaderRoute: typeof RoomRoomIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/organization': {
      id: '/_app/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AppOrganizationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/': {
      id: '/_app/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AppAgentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/generate': {
      id: '/_app/agents/generate'
      path: '/agents/generate'
      fullPath: '/agents/generate'
      preLoaderRoute: typeof AppAgentsGenerateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/$agentId': {
      id: '/_app/agents/$agentId'
      path: '/agents/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AppAgentsAgentIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/agents/$agentId/': {
      id: '/_app/agents/$agentId/'
      path: '/'
      fullPath: '/agents/$agentId/'
      preLoaderRoute: typeof AppAgentsAgentIdIndexRouteImport
      parentRoute: typeof AppAgentsAgentIdRoute
    }
    '/_app/agents/$agentId/config': {
      id: '/_app/agents/$agentId/config'
      path: '/config'
      fullPath: '/agents/$agentId/config'
      preLoaderRoute: typeof AppAgentsAgentIdConfigRouteImport
      parentRoute: typeof AppAgentsAgentIdRoute
    }
    '/_app/agents/$agentId/analytics': {
      id: '/_app/agents/$agentId/analytics'
      path: '/analytics'
      fullPath: '/agents/$agentId/analytics'
      preLoaderRoute: typeof AppAgentsAgentIdAnalyticsRouteImport
      parentRoute: typeof AppAgentsAgentIdRoute
    }
  }
}

interface AppAgentsAgentIdRouteChildren {
  AppAgentsAgentIdAnalyticsRoute: typeof AppAgentsAgentIdAnalyticsRoute
  AppAgentsAgentIdConfigRoute: typeof AppAgentsAgentIdConfigRoute
  AppAgentsAgentIdIndexRoute: typeof AppAgentsAgentIdIndexRoute
}

const AppAgentsAgentIdRouteChildren: AppAgentsAgentIdRouteChildren = {
  AppAgentsAgentIdAnalyticsRoute: AppAgentsAgentIdAnalyticsRoute,
  AppAgentsAgentIdConfigRoute: AppAgentsAgentIdConfigRoute,
  AppAgentsAgentIdIndexRoute: AppAgentsAgentIdIndexRoute,
}

const AppAgentsAgentIdRouteWithChildren =
  AppAgentsAgentIdRoute._addFileChildren(AppAgentsAgentIdRouteChildren)

interface AppRouteChildren {
  AppOrganizationRoute: typeof AppOrganizationRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAgentsAgentIdRoute: typeof AppAgentsAgentIdRouteWithChildren
  AppAgentsGenerateRoute: typeof AppAgentsGenerateRoute
  AppAgentsIndexRoute: typeof AppAgentsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppOrganizationRoute: AppOrganizationRoute,
  AppIndexRoute: AppIndexRoute,
  AppAgentsAgentIdRoute: AppAgentsAgentIdRouteWithChildren,
  AppAgentsGenerateRoute: AppAgentsGenerateRoute,
  AppAgentsIndexRoute: AppAgentsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  PolicyRoute: PolicyRoute,
  RoomRoomIdRoute: RoomRoomIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
